module.exports = __webpack_public_path__ + "media/images/news/wb-0f1ff8bca1557bb53c25e4269eb532e9.png";